// Colors extracted directly from Tailwind config
// This mirrors the colors defined in tailwind.config.js
export const colors = {
  // Primary colors
  primary950: "#000A19",
  primary900: "#001d47",
  primary800: "#003075",
  primary700: "#0043a3",
  primary600: "#0056d1",
  primary500: "#0068ff",
  primary400: "#2e83ff",
  primary300: "#5c9fff",
  primary200: "#8abaff",
  primary100: "#b8d5ff",
  primary50: "#eef2f6",

  // Secondary colors
  secondary700: "#82A300",
  secondary600: "#A6D100",
  secondary500: "#CBFF00",
  secondary300: "#DEFF5C",
  secondary200: "#E7FF8A",

  // Green colors
  green950: "#0A2928",
  green900: "#1B4642",
  green700: "#1D6860",
  green600: "#1F8276",
  green550: "#89C6A7",
  green500: "#2AA291",
  green400: "#50C2B0",
  green350: "#52C41A",
  green300: "#71D7C4",
  green200: "#A5EADA",
  green100: "#D2F5EC",
  green50: "#F2FBF9",

  // Chicago (gray) colors
  chicago950: "#0D0D0D",
  chicago500: "#808080",
  chicago400: "#969696",
  chicago300: "#ADADAD",
  chicago200: "#C4C4C4",
  chicago100: "#DBDBDB",
  chicago50: "#F2F2F2",

  // Black colors
  black600: "#5D5D5D",
  black400: "#888888",
  black300: "#B0B0B0",
  black200: "#D1D1D1",

  // Gray colors (for archived status)
  gray700: "#374151",
  gray200: "#e5e7eb",
  
  // Red colors (for inactive status)
  red600: "#dc2626",
  red200: "#fecaca",
  
  // Other utility colors
  removeRed: "#FF4D4F",
  roman500: "#D9594C",
  roman400: "#E98A80",
  roman300: "#F2B5AF",
  ownerBlock: "#396EB8",
  previousBooking: "#3D3D3D",
  informationPrimary300: "#91CAFF",
  informationPrimary100: "#E6F4FF",
  borderGray: "#E6E7E7",
} as const;

export const PRIMARY_600 = colors.primary600;
export const BORDER_GRAY = colors.borderGray;
export const CHICAGO_400 = colors.chicago400;
